import makeStyles from "e100-react-components/lib/styles/makeStyles";

export const useStyles = makeStyles(() => ({
  iconList: {
    minWidth: "24px",
  },
  iconContainer: {
    display: "flex",
  },
}));
